export enum CreationSourceType {
  API = 'API',
  DEPENDENT = 'DEPENDENT',
  CARRIER = 'CARRIER',
  WEB_PARTICIPANT_PORTAL = 'WEB_PARTICIPANT_PORTAL',
  WEB_ADMIN_PORTAL = 'WEB_ADMIN_PORTAL',
}

export enum DependentStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface Dependent {
  id?: string;
  firstName?: string;
  lastName?: string;
  ssn?: string;
  birthOn?: string;
  relationshipType?: string;
  creationSourceType?: CreationSourceType;
  status?: DependentStatusEnum;
}

export interface DependentPayload {
  dependent_id?: number;
  first_name?: string;
  last_name?: string;
  ssn?: string;
  birth_on?: string;
  local_date_birth_on?: string;
  relationship_type?: string;
  creation_source_type?: CreationSourceType;
  status?: DependentStatusEnum;
}
